import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchAssetAlerts } from "../thunk/MapSliceThunk";

const initialData: any = [];

const AssetAlertSlice: Slice<any, {}, "AssetAlertSlice"> = createSlice({
    name: "AssetAlertSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchAssetAlerts.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchAssetAlerts.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchAssetAlerts.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default AssetAlertSlice